/**
 * NewBuildingsLegend - Легенда классов новостроек
 *
 * Мигрирована на новую систему легенд (Этап 2)
 * Использует LegendRenderer с типом COLORED_ITEMS
 */

import React from 'react';
import { t } from '@lingui/macro';
import { LegendRenderer } from '../../LegendRenderer';
import { NEW_BUILDINGS_LEGEND } from '../../../constants/legends';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';

const NewBuildingsLegendComponent = () => (
    <LegendRenderer config={NEW_BUILDINGS_LEGEND} />
);

export const NewBuildingsLegend = withDisplayedLayersCheck(
    NewBuildingsLegendComponent,
    t`Новостройки`
);
